/**
 * Admin Interface Styled Components
 *
 * Global admin-level styled components.
 *
 * @since 1.0.0
 */

import styled from '@emotion/styled';

export const AdminContainer = styled.div`
  margin: 0;
  padding: 12px 0 0;

  .wrap {
    margin: 0;
    padding: 0;
    max-width: none;

    h1 {
      display: none; /* Hide WordPress default h1 since we have our own */
    }
  }

  /* Remove WordPress admin notice margins that could interfere */
  .notice,
  .error,
  .updated {
    margin: 16px 0 !important;
  }

  /* Override WordPress admin styles that might interfere */
  * {
    box-sizing: border-box;
  }

  /* Ensure the main app takes full height */
  #wpbody-content {
    padding: 0 !important;
  }

  #wpcontent {
    padding: 0 !important;
  }
`;
